<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg543"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs547"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath557"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path555" /></clipPath></defs><g
     id="g549"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g551"><g
         id="g553"
         clip-path="url(#clipPath557)"><g
           id="g559"
           transform="translate(474.5,20.25)"><path
             d="m 0,0 h 24 c 3.31,0 6,2.69 6,6 v 224.22 c 0,3.31 -2.69,6 -6,6 h -485 c -3.31,0 -6,-2.69 -6,-6 V 6 c 0,-3.31 2.69,-6 6,-6 h 426"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path561" /></g><g
           id="g563"
           transform="translate(47.5,139.8589)"><path
             d="m 0,0 v 73.608 c 0,1.657 1.343,3 3,3 h 70.73 c 1.657,0 3,-1.343 3,-3 V 0 c 0,-1.657 -1.343,-3 -3,-3 H 3 C 1.343,-3 0,-1.657 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path565" /></g><g
           id="g567"
           transform="translate(47.1797,469.4302)"><path
             d="m 0,0 v 16.32 c 0,3.31 2.69,6 6,6 h 405.641 c 3.309,0 6,-2.69 6,-6 v -229.28"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path569" /></g><g
           id="g571"
           transform="translate(47.1797,256.4702)"><path
             d="M 0,0 V 177.96"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path573" /></g><g
           id="g575"
           transform="translate(353.4502,448.75)"><path
             d="m 0,0 h -261.271 c -1.099,0 -2,-0.9 -2,-2 v -31.63 c 0,-1.11 0.901,-2 2,-2 H -28.23"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path577" /></g><g
           id="g579"
           transform="translate(421.8184,400.6631)"><path
             d="m 0,0 c 0,-5.288 -5.048,-9.713 -6.597,-14.484 -1.605,-4.945 -0.178,-11.481 -3.174,-15.597 -3.026,-4.157 -9.703,-4.806 -13.86,-7.831 -4.115,-2.995 -6.78,-9.162 -11.724,-10.768 -4.771,-1.549 -10.53,1.824 -15.817,1.824 -5.288,0 -11.046,-3.373 -15.817,-1.824 -4.945,1.606 -7.609,7.773 -11.725,10.768 -4.157,3.026 -10.834,3.675 -13.859,7.832 -2.995,4.116 -1.57,10.651 -3.175,15.596 -1.549,4.771 -6.596,9.197 -6.596,14.484 0,5.288 5.047,9.713 6.597,14.484 1.605,4.945 0.179,11.481 3.174,15.597 3.025,4.157 9.703,4.806 13.859,7.831 4.116,2.996 6.78,9.162 11.726,10.768 4.77,1.549 10.528,-1.824 15.816,-1.824 5.287,0 11.046,3.373 15.817,1.824 4.945,-1.606 7.609,-7.773 11.725,-10.768 4.156,-3.025 10.834,-3.674 13.859,-7.831 2.996,-4.116 1.569,-10.652 3.174,-15.597 C -5.048,9.713 0,5.288 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path581" /></g><g
           id="g583"
           transform="translate(391.7217,400.6631)"><path
             d="m 0,0 c 0,-11.64 -9.436,-21.076 -21.075,-21.076 -11.64,0 -21.076,9.436 -21.076,21.076 0,11.64 9.436,21.076 21.076,21.076 C -9.436,21.076 0,11.64 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path585" /></g><g
           id="g587"
           transform="translate(406.6699,366.73)"><path
             d="m 0,0 v -63.41 c 0,-1.42 -1.45,-2.39 -2.76,-1.85 l -32.5,13.38 c -0.49,0.2 -1.04,0.2 -1.52,0 l -32.5,-13.38 c -1.32,-0.54 -2.77,0.43 -2.77,1.85 V 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path589" /></g><g
           id="g591"
           transform="translate(90.1816,383.1196)"><path
             d="M 0,0 H 199.079"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path593" /></g><g
           id="g595"
           transform="translate(90.1816,353.1196)"><path
             d="M 0,0 H 199.079"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path597" /></g><g
           id="g599"
           transform="translate(90.1816,293.1196)"><path
             d="M 0,0 H 113.514"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path601" /></g><g
           id="g603"
           transform="translate(90.1816,323.1196)"><path
             d="M 0,0 H 199.079"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path605" /></g><g
           id="g607"
           transform="translate(109.0449,192.6938)"><path
             d="M 0,0 C 10.48,0 10.48,-5.031 20.96,-5.031 31.442,-5.031 31.442,0 41.924,0 52.405,0 52.405,-5.031 62.887,-5.031"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path609" /></g><g
           id="g611"
           transform="translate(109.0449,165.6631)"><path
             d="M 0,0 C 10.48,0 10.48,-5.031 20.96,-5.031 31.442,-5.031 31.442,0 41.924,0 52.405,0 52.405,-5.031 62.887,-5.031"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path613" /></g><g
           id="g615"
           transform="translate(345.0713,216.4673)"><path
             d="M 0,0 H 119.429"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path617" /></g><g
           id="g619"
           transform="translate(345.0713,189.4673)"><path
             d="M 0,0 H 119.429"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path621" /></g><g
           id="g623"
           transform="translate(345.0713,162.4673)"><path
             d="M 0,0 H 94.429"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path625" /></g><g
           id="g627"
           transform="translate(272.9775,60.25)"><path
             d="m 0,0 25.506,66.97 c 0.521,1.274 2.325,1.276 2.848,0.002 L 53.629,0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path629" /></g><g
           id="g631"
           transform="translate(280.9316,76.9287)"><path
             d="M 0,0 H 37.849"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path633" /></g><g
           id="g635"
           transform="translate(352.2783,60.25)"><path
             d="M 0,0 V 67.799 L 45.839,1.422 c 0.849,-1.228 1.76,-0.626 1.76,0.867 l -0.635,65.637"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path637" /></g><g
           id="g639"
           transform="translate(425.5488,128.1763)"><path
             d="M 0,0 V -67.926"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path641" /></g><g
           id="g643"
           transform="translate(462.0889,127.3193)"><path
             d="M 0,0 -34.366,-31.588 2.411,-67.069"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path645" /></g><g
           id="g647"
           transform="translate(245.168,112.5464)"><path
             d="m 0,0 c 0,-8.632 -6.998,-15.63 -15.63,-15.63 -4.281,0 -19.73,-0.069 -19.73,-0.069 V 0 15.63 h 19.73 C -6.998,15.63 0,8.632 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path649" /></g><g
           id="g651"
           transform="translate(251.2676,78.6143)"><path
             d="m 0,0 c 0,-10.098 -8.186,-18.284 -18.283,-18.284 -5.008,0 -23.177,-0.08 -23.177,-0.08 V 0 18.284 h 23.177 C -8.186,18.284 0,10.098 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path653" /></g></g></g></g></svg>
</template>
